module.exports = __webpack_public_path__ + "static/img/w_default_avatar.6a45b1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/images/w_default_avatar.jpg
// module id = Mzfn
// module chunks = 80